module.exports = __webpack_public_path__ + "assets/5a205420a1d40ef06229d8a538310457.mp3";